import React, { forwardRef, useRef, useCallback, useImperativeHandle } from 'react';

import { Icon } from 'shared/components/Icon/Icon';

import { InputWrapper } from './StyledInput';

const Input = forwardRef(({ hideIcon, icon, ...props }, ref) => {
  const inputRef = useRef(null);

  const onIconClick = useCallback(() => inputRef.current.focus(), []);
  useImperativeHandle(ref, () => inputRef);

  return (
    <InputWrapper>
      <input {...props} ref={inputRef} id={props.name} readOnly />
      {!hideIcon && <Icon icon={icon} height={50} as="label" onClick={onIconClick} />}
    </InputWrapper>
  );
});

Input.defaultProps = {
  icon: 'icon-calendar',
};

export { Input };
